export default __webpack_public_path__ + "static/media/top-cover-bg.a366474a.png";